export const toHash = (str: string): string => `#${str.replace(/ /g, '-')}`